var angular = require('angular');
require('ngclipboard');

export default angular.module('asCopy', ['ngclipboard']).component('asCopy', {
    template: require('./asCopy.component.html'),
    styleUrls: require('./asCopy.component.css'),
    controller: asCopyComponent,
    bindToController: true,
    bindings: {
        id: '<',
        text: '<',
        hidecopybutton: '<',
        copymessage: '<'
    }
});

function asCopyComponent($scope) {
    var vm = this;
    let timeout = null;

    vm.$onInit = function() {
        if (vm.id === undefined) {
            vm.id = guidGenerator();
        }
    };

    vm.copy = () => {
        if (vm.copymessage != undefined) {
            showTooltip(vm.copymessage);
        }
    };

    function guidGenerator() {
        var S4 = function() {
            return ((1 + Math.random()) * 0x10000) | 0;
        };
        return 'copy-target' + S4();
    }

    function showTooltip(msg) {
        $scope.$evalAsync(function() {
            $scope.popoverText = msg;
            $scope.isOpen = true;
            delayHideTooltip();
        });
    }

    function delayHideTooltip() {
        if (timeout) {
            clearTimeout(timeout);
            timeout = null;
        }
        timeout = setTimeout(function() {
            $scope.$evalAsync(function() {
                $scope.isOpen = false;
            });
        }, 1000);
    }
}



// WEBPACK FOOTER //
// ./modules/shared/asCopy/asCopy.component.js